import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { routes } from '../../config/routes.config';

export const AppRoutes: React.FC = () => {
    return (
        <Routes>
            {routes.map(({ path, component: Component }) => (
                <Route
                    key={path}
                    path={path}
                    element={<Component />}
                />
            ))}
        </Routes>
    );
}; 